import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export const Payments = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_16};
`;

export const Reviews = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_24};
`;

export const AppLinks = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_16};
`;

export const AppLink = styled.a`
  display: flex;
`;
export const StoreLinks = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.spacing_16};

  ${({ theme }) => theme.breakpointsV2.desktop} {
    flex-direction: column;
  }
`;

export const QRContainer = styled.div`
  display: none;
  padding: ${({ theme }) => theme.spacing.spacing_4};
  background: ${props => props.theme.palette.white};
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  box-sizing: border-box;

  ${({ theme }) => theme.breakpointsV2.desktop} {
    display: block;
  }
`;
